export function is_dev(): boolean {
    // process.env.NODE_ENV: production, development, test
    return process.env.NODE_ENV === 'development';
}

export function debug_log(...msgs: any): void {
    if (is_dev()) {
        console.log(...msgs);

        if (Error.captureStackTrace) {
            let trace = {stack: ''};
            Error.captureStackTrace(trace, debug_log);
            // ドキュメントが整備されてなく、恐らく今後変わる可能性もありそうだが、
            // MS Edge 101 , Chrome 102 では、 trace.stack に スタックトレースが文字列として格納される
            // 一行目は "Error" 固定。 2行目が 呼び出し元。
            console.log(trace.stack.split("\n")[1]);
        }
    }
}
